import { render } from "./SelectedProducts.vue?vue&type=template&id=4f8e695b&ts=true"
import script from "./SelectedProducts.vue?vue&type=script&lang=ts"
export * from "./SelectedProducts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__